import JButton from './button'

export default JButton



// WEBPACK FOOTER //
// ./src/components/button/index.js